import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { currencyInputFormatter } from './CurrencyInputFormatter';
import useReimbursementStore from '../../../screens/Forms/useReimbursementStore';
import styles from '../Reimbursement.module.css';

export const UnitPriceInput = ({
    row,
    cell,
    field,
    disabled = false,
    onValidPrice,
    validator,
    forceUpdate,
    validationFired,
    hasError
}) => {
    const [inputValue, setInputValue] = useState(cell ?? '');
    const updateRow = useReimbursementStore((state) => state.updateRow);
    const fieldName = `price_${row.id}`;
    const validationMessage = validator?.message(fieldName, row.price, 'required|min:0.01,num', {
        className: 'errorMsg',
        messages: { min: 'Unit price must exceed $0.' }
    });
    const hasValidationError = (validationFired && hasError) || Boolean(validationMessage);

    useEffect(() => {
        setInputValue(cell ?? '');
    }, [cell]);

    return (
        <div className={styles.unitPriceFieldWrap}>
            <NumberFormat
                key={[row.id, 'unit', field].join('_')}
                className={`form-control ${hasValidationError ? styles.formError : ''}`}
                disabled={disabled}
                prefix='$'
                thousandSeparator
                decimalScale={2}
                fixedDecimalScale
                format={currencyInputFormatter}
                value={inputValue}
                onValueChange={({ value }) => {
                    setInputValue(value ?? null);
                    if (validator) {
                        validator.hideMessageFor(fieldName);
                    }
                }}
                onBlur={() => {
                    const finalValue = parseInt(inputValue, 10) / 100;
                    if (finalValue == null || Number.isNaN(finalValue)) {
                        updateRow(null, field, row.id);
                        if (validator) {
                            validator.showMessageFor(fieldName);
                            forceUpdate?.();
                        }
                        return;
                    }
                    updateRow(finalValue, field, row.id);
                    if (finalValue <= 0) {
                        if (validator) {
                            validator.showMessageFor(fieldName);
                            forceUpdate?.();
                        }
                        return;
                    }
                    if (onValidPrice) {
                        onValidPrice(row.id);
                    }
                }}
            />
            <div
                className={`${styles.unitPriceValidationSlot} ${hasValidationError ? styles.unitPriceValidationSlotReserved : ''}`}
            >
                {validationMessage}
            </div>
        </div>
    );
};

export default UnitPriceInput;
